import {StringTranslations} from '../../../common/types/StringTranslations';

export interface Tile {
  readonly id: string;
  readonly name?: StringTranslations;
  readonly type: TileType;
  readonly description?: StringTranslations;
  readonly tag?: StringTranslations;
  readonly collectionId?: string;
  readonly artisticObjectId?: string;
  readonly placeId?: string;
  readonly path?: string;
  readonly width: number;
  readonly height: number;
}

export enum TileType {
  COLLECTION = 'COLLECTION',
  ARTISTIC_OBJECT = 'ARTISTIC_OBJECT',
  PLACE = 'PLACE',
  PATH = 'PATH'
}

export interface TileListingInfo {
  readonly id: string;
  readonly name?: StringTranslations;
  readonly type: TileType;
  readonly collectionName?: string;
  readonly artisticObjectName?: string;
  readonly placeName?: string;
  readonly path?: string;
}

